import VersionsInfo from './VersionsInfo.component';

export * from './VersionsInfo.styled';

export default VersionsInfo;
